import { render, staticRenderFns } from "./ArticleDirections.vue?vue&type=template&id=c2069df6&scoped=true&"
import script from "./ArticleDirections.vue?vue&type=script&lang=js&"
export * from "./ArticleDirections.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDirections.vue?vue&type=style&index=0&id=c2069df6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2069df6",
  null
  
)

export default component.exports